import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  FaArrowLeft,
  FaCartPlus,
  FaTruckMoving,
  FaCheckCircle,
  FaUserCircle,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaMap,
} from "react-icons/fa";
import { MdLocalFlorist } from "react-icons/md";
import { IoCubeOutline } from "react-icons/io5";
import api from "../../api";
import Navbar from "../Core/Navbar";
import Footer from "../Core/Footer";
import TrackLine from "../TrackLine.jsx";

const OrderDetails = () => {
  const navigate = useNavigate();
  // const { trackingNo } = useParams();

  const [historyDetail, setHistoryDetail] = useState([]);
  const [status, setStatus] = useState("");
  const [address, setAddress] = useState({});
  const [orderId, setOrderId] = useState("");
  const [subtotal, setSubtotal] = useState("");
  const [tax, setTax] = useState("");
  const [total, setTotal] = useState("");
  const [cancel, setCancel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [invoiceUrl, setInvoiceUrl] = useState("");
  const [loader, setLoader] = useState(false);
  let { tracking_id } = useParams();
  console.log("tracking_id", tracking_id);

  const progressTabs = ["Ordered", "Processing", "Arriving", "Delivered"];
  const activeTab = "Processing";

  const accessToken = localStorage.getItem("accessToken");

  const getHistoryList = async () => {
    setLoader(true);
    try {
      const response = await api.get(
        `/user_api/track-order-details?access_token=${JSON.parse(
          accessToken
        )}&tracking_no=${tracking_id}`
      );
      const data = response.data;
      console.log("data", data);

      setHistoryDetail(data.order_details || []);
      setAddress(data.user_address || {});
      setOrderId(data.order_id);
      setSubtotal(data.subtotal);
      setTax(data.total_tax);
      setTotal(data.grand_total);
      setCancel(data.cancel_button);
      setInvoiceUrl(data.invoice || "");
      setStatus(data.order_status);
      if (data.order_status === "Cancelled") {
        setCurrentStep(4);
      }
      if (data.order_status === "Delivered") {
        setCurrentStep(3);
      }
      if (data.order_status === "Arrived") {
        setCurrentStep(2);
      }
      if (data.order_status === "Accepted") {
        setCurrentStep(1);
      }
      if (data.order_status === "Pending") {
        setCurrentStep(0);
      }
    } catch (error) {
      console.error("Error fetching cart:", error.response);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getHistoryList();
  }, []);

  const handleCancelOrder = async () => {
    setLoading(true);
    try {
      const response = await api.post("/user_api/cancel-order", {
        access_token: JSON.parse(accessToken),
        order_id: orderId,
      });
      if (response.data.status === "success") {
        getHistoryList();
        alert(response.data.message);
      }
    } catch (error) {
      alert(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  console.log("orderId", orderId);

  // historyDetail.map((item) =>
  //   setStatus(item.status)
  // )

  return (
    <div>
      <Navbar />
      <div style={styles.container}>
        {/* Content */}
        <div style={styles.content}>
          <h3 style={styles.thankYouText}>
            Thank you! Your order:{" "}
            <span style={{ color: "#28A745" }}>#{tracking_id}</span>
          </h3>
          <p style={styles.normalText}>Check email address or tracking here.</p>

          {/* trackline */}
          <div>
            <TrackLine currentStep={currentStep} />
          </div>

          {/* Delivery box */}
          <div style={styles.deliveryBox}>
            <MdLocalFlorist size={28} color="#7D3D8A" />
            <div style={{ marginLeft: 10 }}>
              <p style={styles.normalText}>
                Your order will delivery about 2 days.
              </p>
            </div>
          </div>

          {/* Address */}

          {loader ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 20,
              }}
            >
              <p style={{ fontSize: "30px" }}>Loading...</p>
            </div>
          ) : (
            <div style={styles.addressBox}>
              <div style={styles.row}>
                <FaUserCircle size={18} color="#333" />
                <span style={styles.addressText}>
                  {address.first_name} {address.last_name}
                </span>
              </div>
              <div style={styles.row}>
                <FaPhoneAlt size={18} color="#333" />
                <span style={styles.addressText}>{address.number}</span>
              </div>
              <div style={styles.row}>
                <FaMapMarkerAlt size={18} color="#333" />
                <span style={styles.addressText}>{address.address}</span>
              </div>
              <div style={styles.row}>
                <FaMap size={18} color="#333" />
                <span style={styles.addressText}>
                  {address.city}, {address.state}, {address.post_code}
                </span>
              </div>
            </div>
          )}

          {/* Product list */}
          <div style={styles.productsContainer}>
            {historyDetail.map((item) => (
              <div key={item.id} style={styles.productCard}>
                <img
                  src={item.product_image}
                  alt={item.product_name}
                  style={styles.productImage}
                />
                <div style={{ flex: 1 }}>
                  <p style={styles.productName}>{item.product_name}</p>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: 10,
                      gap: 6,
                    }}
                  >
                    <span style={styles.soldText}>Status:</span>
                    <span style={{ color: "#28A745", fontWeight: "bold" }}>
                      {item.status}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Summary */}
          <div style={styles.addressBox}>
            <div style={styles.bottomRow}>
              <span style={styles.normalText}>Subtotal</span>
              <span style={styles.normalText}>AED{subtotal}</span>
            </div>
            <div style={styles.bottomRow}>
              <span style={styles.normalText}>Tax</span>
              <span style={styles.normalText}>AED{tax}</span>
            </div>
            <div style={styles.divider}></div>
            <div style={styles.bottomRow}>
              <span style={styles.productName}>Total</span>
              <span style={styles.productName}>AED{total}</span>
            </div>
          </div>

          {/* Cancel Button */}
          {cancel && (
            <button
              onClick={handleCancelOrder}
              disabled={loading}
              style={styles.cancelButton}
            >
              {loading ? "Cancelling..." : "Cancel"}
            </button>
          )}
          {status === "Arrived" && invoiceUrl && (
            <button style={styles.invoiceButton} onClick={() => window.open(invoiceUrl, '_blank')}>
              <Link
              
                target="_blank"
                rel="noopener noreferrer"
                style={styles.invoiceButton1}
              >
                Download Invoice
              </Link>
            </button>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    minHeight: "100vh",
    backgroundColor: "#fff",
    padding: 16,
    boxSizing: "border-box",
  },
  header: {
    padding: 16,
    borderBottom: "1px solid #ccc",
  },
  headerTitle: {
    marginLeft: 10,
    fontSize: 20,
    fontWeight: "bold",
    color: "#283716",
  },
  content: {
    maxWidth: 1000,
    margin: "20px auto",
  },
  thankYouText: {
    fontSize: 18,
    fontWeight: "bold",
  },
  normalText: {
    fontSize: 14,
    color: "#666",
    margin: "0",
  },
  deliveryBox: {
    marginTop: 20,
    display: "flex",
    alignItems: "center",
    backgroundColor: "#DFF6DD",
    padding: 12,
    borderRadius: 8,
  },
  addressBox: {
    backgroundColor: "#f8f8f8",
    padding: 16,
    borderRadius: 8,
    marginTop: 20,
  },
  row: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 10,
  },
  addressText: {
    fontSize: 14,
    color: "#333",
  },
  productsContainer: {
    marginTop: 20,
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  productCard: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    borderRadius: 8,
    padding: 10,
    gap: 12,
  },
  productImage: {
    width: 80,
    height: 80,
    objectFit: "cover",
    borderRadius: 8,
  },
  productName: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#333",
  },
  soldText: {
    fontSize: 14,
    color: "#888",
  },
  bottomRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  divider: {
    height: 1,
    backgroundColor: "#ccc",
    margin: "12px 0",
  },
  cancelButton: {
    width: "100%",
    marginTop: 20,
    padding: 12,
    borderRadius: 8,
    border: "1px solid red",
    backgroundColor: "#fff",
    color: "red",
    fontWeight: "bold",
    fontSize: 16,
    cursor: "pointer",
  },
  invoiceButton: {
    marginTop: 20,
    width: "100%",

    padding: 12,
    borderRadius: 8,
    border: "1px solid #7D3D8A",
    backgroundColor: "#7D3D8A",
    color: "white",
    fontWeight: "bold",
    fontSize: 16,
    cursor: "pointer",
    textAlign: "center",
    textDecoration: "none",
  },
  invoiceButton1: {
    color: "white",
 width: "100%",
textAlign: "center",
    textDecoration: "none",
  },
};

export default OrderDetails;
